import { howAppIsRunning } from '@/utils/commonUtils';
import { DEV } from '@/constants/constants';

export const taggingButtonTypes = {
  MENU: 'menu',
  BUTTON: 'boton',
  LINK: 'enlace',
  TAB: 'tab',
  DIALOGUE: 'dialogo',
};
export const sendButtonTagging = (eventType, value) => {
  if (howAppIsRunning() !== DEV) {
    const { dataLayer } = window;
    if (dataLayer) {
      //T=DO usar funciones de bit
      // dataLayer.push({
      //   event: 'boton',
      //   APeventAction: eventType,
      //   APeventLabel: value,
      // });
    }
  }
};
export const sendManagementTagging = (actionValue, labelValue) => {
  if (howAppIsRunning() !== DEV) {
    const { dataLayer } = window;
    // TODO usar metodso de bit
    // dataLayer.push({
    //   GAcategory: 'eServicing',
    //   GAaction: actionValue,
    //   GAlabel: labelValue,
    //   event: 'asyncGTM',
    // });
  }
};
export const detectCorrectButtonType = (typeToTest) => {
  let correctType = false;
  Object.keys(taggingButtonTypes).forEach((typeName) => {
    if (typeToTest === taggingButtonTypes[typeName]) {
      correctType = true;
    }
  });
  return correctType;
};

export const push2DataLayer = (
  event = '',
  GAcategory = '',
  GAaction = '',
  GAlabel = ''
) => {
  if (howAppIsRunning() !== DEV) {
    const { dataLayer } = window;
    const numberOfEvents = dataLayer.length;
    let eventCounter = 0;
    let pushConfirmation = true;
    for (
      let dlindex = numberOfEvents - 1;
      dlindex >= 0 && eventCounter < 5;
      dlindex -= 1
    ) {
      const currentEvent = dataLayer[dlindex];
      if (
        GAcategory === currentEvent.GAcategory &&
        GAaction === currentEvent.GAaction
      ) {
        pushConfirmation = false;
        break;
      }
      eventCounter += 1;
    }

    // only push one time
    if (pushConfirmation) {
      // TODO usar metodso de bit
      // dataLayer.push({
      //   event,
      //   GAcategory,
      //   GAaction,
      //   GAlabel,
      // });
    }
  }
};
export const sendTagging = (taggingType, id, managementValue) => {
  if (howAppIsRunning() !== DEV) {
    if (
      !managementValue &&
      taggingType &&
      id &&
      detectCorrectButtonType(taggingType)
    ) {
      sendButtonTagging(taggingType, id);
    }
    if (managementValue && id) {
      sendManagementTagging(managementValue, id);
    }
  }
};

export const buttonTaggHandler = (category, action, label) => {
  push2DataLayer('asyncGTM', category, action, label);
};
